import { render, staticRenderFns } from "./InputBirthday.vue?vue&type=template&id=43dfe751&scoped=true&"
import script from "./InputBirthday.vue?vue&type=script&lang=ts&"
export * from "./InputBirthday.vue?vue&type=script&lang=ts&"
import style0 from "./InputBirthday.vue?vue&type=style&index=0&id=43dfe751&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43dfe751",
  null
  
)

export default component.exports